//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibCommonModal',
  props: {
    big: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: function _default() {}
    },
    icon: {
      type: String,
      default: ''
    },
    okButton: {
      type: Boolean,
      default: false
    },
    okButtonText: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    note: {
      type: String,
      default: ''
    },
    useBaseTheme: {
      type: Boolean,
      default: false
    },
    closeButtonTestIdIdentifier: {
      type: String,
      default: 'default'
    }
  },
  computed: {
    iconName: function iconName() {
      switch (this.icon) {
        case 'negative':
          return 'highlight_off';

        case 'positive':
          return 'check';

        default:
          return this.icon;
      }
    },
    cssVars: function cssVars() {
      var styles = this.styles;
      var defaultColour = styles ? styles.color : null;
      return styles ? {
        '--modal-icon-color': styles.iconColor || defaultColour || '',
        '--modal-text-color': styles.textColor || defaultColour || '',
        '--modal-title-color': styles.titleColor || defaultColour || '',
        '--modal-note-color': styles.noteColor || defaultColour || ''
      } : null;
    }
  }
};